module.exports = __webpack_public_path__ + "img/qrcode.03cac9fe.jpg";